import React from 'react'

import cx from 'helpers/cx'

import { Button } from 'components'
import type { ButtonAsButton, ButtonAsLink, ButtonSize } from 'components/Button'

export const PrimaryButton = ({
  size = 'md',
  ...props
}: Omit<ButtonAsButton, 'variant'> & { size?: Extract<ButtonSize, 'sm' | 'md' | 'lg'> }) => (
  <Button variant="primary" size={size} {...props} />
)

export const AccentButton = (props: Omit<ButtonAsButton, 'variant'>) => (
  <Button variant="accent" {...props} />
)

export const CancelButton = (props: Omit<ButtonAsButton, 'variant'>) => (
  <Button variant="cancel" type="button" {...props} />
)

export const PreviousButton = ({
  to,
  ...props
}: Omit<ButtonAsLink, 'variant'> & { to: ButtonAsLink['to'] }) => (
  <Button variant="cancel" to={to} {...props} />
)

export const DangerButton = ({
  size = 'sm',
  ...props
}: Omit<ButtonAsButton, 'variant'> & { size?: Extract<ButtonSize, 'xs' | 'sm'> }) => (
  <Button variant="danger" size={size} type="button" {...props} />
)

export const NatureButton = ({
  size = 'sm',
  ...props
}: Omit<ButtonAsButton, 'variant'> & { size?: Extract<ButtonSize, 'sm' | 'md' | 'lg'> }) => (
  <Button variant="nature" size={size} type="button" {...props} />
)

export const NatureLink = ({
  size = 'sm',
  to,
  ...props
}: Omit<ButtonAsLink, 'variant'> & {
  size?: Extract<ButtonSize, 'sm' | 'md' | 'lg'>
  to: ButtonAsLink['to']
}) => <Button variant="nature" size={size} to={to} {...props} />

export const NatureAddButton = ({
  size = 'sm',
  ...props
}: Omit<ButtonAsButton, 'variant' | 'withIcon'> & {
  size?: Extract<ButtonSize, 'sm' | 'md' | 'lg'>
}) => <Button variant="nature" size={size} type="button" withIcon {...props} />

export const NatureAddLink = ({
  size = 'sm',
  to,
  ...props
}: Omit<ButtonAsLink, 'variant' | 'withIcon'> & {
  size?: Extract<ButtonSize, 'sm' | 'md' | 'lg'>
  to: ButtonAsLink['to']
}) => <Button variant="nature" size={size} to={to} withIcon {...props} />

const FormActions = ({
  children,
  className,
  spaced,
}: {
  children?: React.ReactNode
  className?: string
  spaced?: boolean
}) => (
  <div className={cx('layout-form-actions', spaced && 'mt-spaced', className)}>{children}</div>
)

export default FormActions
